// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OlZr","top":"styles_top__Qgctt"};